import React, { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../contexts/AppContext";
import { message, Row, Col } from "antd";
import GeneralButton from "../../components/GeneralButton/GeneralButton";
import "../../styles/globals.css";
import "./AccountRegistPage.css";
import { Form, Input, Checkbox } from "antd";
import { ExclamationCircleOutlined, WarningFilled } from "@ant-design/icons";
import Toast from "../../components/Toast/Toast";
import { sendCertificationNumberMailWhenAccountRegist } from "../../services/service";
import { validatePassword } from "../../utils/validationUtils";
import { encodeToBase64 } from "../../utils/commonUtils";
import { Mail_TYPES } from "../../config/setting";
/**
 * メールアドレスで登録画面用のコンポーネント
 * @param {} なし
 * @return {} なし
 */
function AccountRegistPage() {
  const navigate = useNavigate();
  const { globalReservationInput } = useContext(AppContext);
  const [form] = Form.useForm();
  const [errors, setErrors] = useState({
    password: false,
  });

  const [errorMessage, setErrorMessage] = useState(null);
  const [agreementChecked, setAgreementChecked] = useState(false);
  useEffect(() => {
    setAgreementChecked(false);
  }, []);

  //パスワード登録処理
  const handlePasswordRegistClick = async () => {
    try {
      await form.validateFields({
        validateOnly: true,
      });
      const values = form.getFieldsValue();
      const { password } = values;

      try {
        const data = await sendCertificationNumberMailWhenAccountRegist(
          globalReservationInput?.email,
          globalReservationInput?.kanjiLast,
          globalReservationInput?.kanjiFirst,
          Mail_TYPES.FIRSTSEND.string,
          encodeToBase64(password)
        );
        if (data.result.status === "OK") {
          // 認証番号入力画面に遷移
          navigate("/account-regist/certificatrion-number-input");
          showToast("認証番号メールを送付しました", "success");
        } else {
          // エラーメッセージセット
          setErrorMessage(data?.result?.error_message);
          showToast(data?.result?.error_message, "error");
        }
      } catch (error) {
        console.error(
          "Error sendCertificationNumberMailWhenAccountRegist:",
          error
        );
        showToast("パスワード登録に失敗しました", "error");
      }
    } catch (error) {
      const fieldErrors = error.errorFields.reduce((acc, field) => {
        acc[field.name[0]] = true;
        return acc;
      }, {});
      setErrors(fieldErrors);
      showToast("入力に不備があります。ご確認ください", "error");
    }
  };

  /**
   * 値変更時の処理
   * @param {string} fieldName - フィールド名
   */
  const onValueChange = async (fieldName) => {
    try {
      await form.validateFields([fieldName]);
      setErrors({ ...errors, [fieldName]: false });
      setErrorMessage(null);
    } catch (error) {
      setErrors({ ...errors, [fieldName]: true });
      setErrorMessage(
        "半角英数字、記号を組み合わせた13文字以上で入力してください"
      );
    }
  };

  // トースト通知を表示する関数
  const showToast = (content, type) => {
    const key = `open${Date.now()}`;
    const closeToast = () => {
      message.destroy(key);
    };
    message.open({
      content: <Toast content={content} type="check" onClose={closeToast} />,
      key,
      className: `ant-message-notice-content-${type}`,
    });
  };

  /**
   * 同意チェックボックス変更時の処理
   * @param {object} e - イベントオブジェクト
   */
  const handleAgreementChange = (e) => {
    setAgreementChecked(e.target.checked);
  };

  /**
   * リンククリック時の処理
   */
  const handleLinkClick = () => {
    navigate("/mypage/account-login");
  };

  return (
    <div className="account-regist">
      <div className="main-area">
        <div className="title">メールアドレスで登録</div>
        <div className="detail">
          ログイン用のパスワードを入力してください。
          <br />
          下記のメールアドレスにて登録します。
        </div>

        <div className="form">
          <Form
            form={form}
            name="password-regist"
            layout="vertical"
            initialValues={{ remember: true }}
          >
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  className="ant-label"
                  label="登録メールアドレス"
                  name="email"
                  values={globalReservationInput?.email}
                >
                  <label className="email-label">
                    <div className="email-area">
                      {globalReservationInput?.email}
                    </div>
                  </label>
                  <div className="email-direction">
                    ※メールの受信制限をされている方は、当社ドメイン
                    <br />
                    「wemex.com」を指定受診設定してください。
                  </div>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16} className="password-row">
              <span className="explanation-string">
                ※半角英数字、記号を組み合わせた13文字以上
              </span>
              <Col span={24}>
                <Form.Item
                  className="ant-label"
                  label="パスワード"
                  name="password"
                  rules={[
                    { required: true, message: "パスワードを入力してください" },
                    { validator: validatePassword },
                  ]}
                >
                  <Input.Password
                    className="ant-input"
                    placeholder="パスワード"
                    suffix={
                      errors.password ? <ExclamationCircleOutlined /> : null
                    }
                    onChange={() => {
                      onValueChange("password");
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={24}>
                <div className="detail">
                  <div className="explanation-area">
                    「
                    <a
                      href={process.env.REACT_APP_TERMS_OF_USE_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      利用規約
                    </a>
                    」<span>と</span>「
                    <a
                      href={process.env.REACT_APP_PRIVACY_POLICY_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      個人情報の取扱いについて
                    </a>
                    」 に同意の上、ご利用ください。
                  </div>
                </div>
              </Col>
            </Row>
            <div className="agreement">
              <Checkbox onChange={handleAgreementChange}>
                利用規約・個人情報の取扱いについてに同意する
              </Checkbox>
            </div>
            {errorMessage && (
              <div className="error-area">
                <div className="icon-area">
                  <WarningFilled className="icon" />
                </div>
                <label>{errorMessage}</label>
              </div>
            )}
          </Form>
        </div>
        <GeneralButton
          buttonLabel="パスワードを登録"
          onClick={handlePasswordRegistClick}
          type={
            Object.values(errors).some((error) => error) || !agreementChecked
              ? "disabled"
              : "primary-blue"
          }
        />
        <div className="explanation-area">
          すでにメールアドレスを登録済の方は
          <a
            href="#"
            className="link"
            onClick={(e) => {
              e.preventDefault();
              handleLinkClick();
            }}
          >
            こちら
          </a>
          からログインしてください。
        </div>
      </div>
    </div>
  );
}

export default AccountRegistPage;
